<template>
  <div class="talk-theme">
    <div class="card">
      <div class="card-body">
        <div :class="className">
          <TalkThemeCreate :room_id="room_id" :user="user" v-if="state.name === states[1].name" />
          <TalkThemeView :text="theme.value" v-if="state.name === states[2].name" />
          <TalkThemeVoting :members="members" :user="user" :room_id="room_id" v-if="state.name === states[3].name" />
          <TalkThemeResultVoting :members="members" v-if="state.name === states[4].name" :isOwner="isOwner" @send-system-message="sendSystemMessage($event, argument)" />
          <!-- <TalkThemeResultGame :members="members" v-if="state.name === states[5].name" /> -->
          <button type="button" name="button" class="btn btn-success" @click="nextState" v-if="isOwner">{{ 'GM: ' + state.buttonText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from 'firebase'

import TalkThemeView from '@/components/TalkTheme/View.vue'
import TalkThemeCreate from '@/components/TalkTheme/Create.vue'
import TalkThemeVoting from '@/components/TalkTheme/Voting.vue'
import TalkThemeResultVoting from '@/components/TalkTheme/ResultVoting.vue'
// import TalkThemeResultGame from '@/components/TalkTheme/ResultGame.vue'

export default {
  name: 'TalkTheme',
  components: {
    TalkThemeView,
    TalkThemeCreate,
    TalkThemeVoting,
    TalkThemeResultVoting,
    // TalkThemeResultGame
  },
  props: {
    room_id: { type: String },
    user: null,
    members: null,
    isOwner: { type: Boolean },
    stateIndex: { type: Number },
    theme: Object,
    // points: null
  },
  data() {
    return {
      states: [{name: 'start', buttonText: 'ゲーム開始', isCenter: true}, {name: 'decideTheme', buttonText: 'お題を選出', isCenter: true}, {name: 'displayTheme', buttonText: '投票に移る', isCenter: true}, {name: 'voting', buttonText: '結果を表示', isCenter: true}, {name: 'resultVoting', buttonText: '終了'}],
      db: null
    }
  },
  computed: {
    state() {
      return this.states[this.stateIndex];
    },
    className() {
      if (this.state === undefined) return 'display'

      if (this.state.isCenter || false){
        return 'display-center';
      }else {
        return 'display';
      }
    }
  },
  methods: {
    nextState() {
      let nextIndex = null;
      if (this.stateIndex < this.states.length - 1){
        nextIndex = this.stateIndex + 1;
      }else {
        nextIndex = 0;
      }
      // const state = this.states[this.stateIndex];

      this.db.collection('rooms').doc(this.room_id).update({
        stateIndex: nextIndex
      }).then(()=>{
        this.changedState();
      });
    },
    selectTheme() {
      this.db.collection('rooms').doc(this.room_id).get().then(doc=>{
        const themes = Object.entries(doc.data().themes).map(([uid, value]) => ({uid, value}));

        const theme = themes[Math.floor(Math.random() * themes.length)];

        this.db.collection('rooms').doc(this.room_id).update({
          theme: theme
        });

        this.sendSystemMessage("お題は「" + theme.value + "」です。話し合いを始めてください。");
      });
    },
    changedState() {
      if (this.state.name === 'start'){
        this.db.collection('rooms').doc(this.room_id).update({
          votes: [],
          isDecidedTheme: {}
        });
      }
      else if (this.state.name === "decideTheme"){
        this.sendSystemMessage('ゲーム開始です。お題を決めてください。')
      }
      else if (this.state.name === 'displayTheme'){
        this.selectTheme();
      }
      else if (this.state.name === 'voting'){
        this.sendSystemMessage('話し合い終了です。お題主だと思うPLに投票してください。')
      }
    },
    // システムメッセージをチャット欄に追加
    sendSystemMessage(message) {
      if (message == ""){return ;}

      // チャットに追加
      this.db.collection('rooms').doc(this.room_id).collection('comments').add({content: message, username: "GM", created: firebase.firestore.FieldValue.serverTimestamp()});
    }
  },
  created() {
    // this.state = this.states[this.stateIndex];
    this.db = firebase.firestore();
  }
}
</script>
<style scoped>
.card {
  height: 30vh;
  overflow: scroll;
}
.card-body {
  position: relative;
}
.display {
  width: 80%;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
}
.display-center {
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%)translateY(-50%);
}
</style>
